<template>
  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <header h1="Employee Report" :exportToExcel="getExportObject()"></header>
          </th>
        </tr>
        <tr>
          <th class="header">
            <img src="\Images\Image.png" alt="The Universal Insurance Company Limited Logo">
            <div class="header-text">
              <div class="title">The Universal Insurance Company Limited</div>
              <div class="subtitle">Know Your Customer (KYC) / Customer Due Diligence (CDD) Form</div>
              <div class="clientreport">Client Report</div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px;">
              <colgroup>
                <col style="width: 10%;">
                <col style="width: 23.3%;">
                <col style="width: 10%;">
                <col style="width: 23.3%;">
                <col style="width: 10%;">
                <col style="width: 23.3%;">
              </colgroup>
              <tr>
                <td class="bg">Branch</td>
                <td>{{branch}}</td>
                <td class="bg">Client Type</td>
                <td>{{clienttype}}</td>
                <td class="bg">Individual CNIC Status</td>
                <td>{{individualcnic}}</td>
              </tr>
              <tr>
                <td class="bg">Director CNIC Status</td>
                <td>{{directorcnic}}</td>
                <td class="bg">Beneficiary CNIC Status</td>
                <td>{{benificiarycnic}}</td>
                <td class="bg">CNIC Verification Status</td>
                <td>{{cnicverification}}</td>
              </tr>
            </table>

            <div class="report-wrapper">
              <table id="tbl2" border="1" width="100%" style="border-collapse:collapse; font-size: 10px; margin-top:10px">
                <thead>
                  <tr>
                    <th class="bg" rowspan="2">Sr.</th>
                    <th class="bg" rowspan="2">Client Code</th>
                    <th class="bg" rowspan="2">Client Category</th>
                    <th class="bg" rowspan="2">Client Name</th>
                    <th class="bg" rowspan="2">Contact No.</th>
                    <th class="bg" rowspan="2">Email</th>
                    <th class="bg" rowspan="2">Address</th>

                    <th class="bg" colspan="3">Individual CNIC</th>
                    <th class="bg" colspan="3">Beneficiary CNIC</th>
                    <th class="bg" colspan="3">Director CNIC</th>

                    <th class="bg" rowspan="2">Verification Status</th>
                    <th class="bg" rowspan="2">City</th>
                    <th class="bg" rowspan="2">Risk History Date</th>
                    <th class="bg" colspan="3">Risk Category</th>
                  </tr>
                  <tr>
                    <th class="bg">CNIC No.</th>
                    <th class="bg">Issue Date</th>
                    <th class="bg">Expiry Date</th>

                    <th class="bg">CNIC No.</th>
                    <th class="bg">Issue Date</th>
                    <th class="bg">Expiry Date</th>

                    <th class="bg">CNIC No.</th>
                    <th class="bg">Issue Date</th>
                    <th class="bg">Expiry Date</th>

                    <th class="bg">Low</th>
                    <th class="bg">Medium</th>
                    <th class="bg">High</th>
                  </tr>
                </thead>


                <tbody>
                  <tr v-for="(item, ind) in clients" :key="item.BP_ID">
                    <td align="center">{{ ind + 1 }}</td>
                    <td align="center">{{ item.BP_CODE_NEW }}</td>
                    <td>{{ item.PTR_TYPE }}</td>
                    <td>{{ item.BP_DSC }}</td>
                    <td>{{ item.BP_MOBILE }}</td>
                    <td>{{ item.BP_EMAIL_ADDRESS }}</td>
                    <td>{{ item.BP_ADDRESS }}</td>

                    <!-- Individual CNIC: BP_MAIN -->
                    <td>{{ item.BP_NIC_NO }}</td>
                    <td>{{ item.BP_CNICISSUEDATE }}</td>
                    <td>{{ item.BP_CNIC_EXPIRYDATE }}</td>

                    <!-- Beneficiary CNIC: BP_BENIOWNERSHIP -->
                    <td>{{ item.BO_BENEFICIARY_CNIC_NO }}</td>
                    <td>{{ item.BO_BENEFICIARY_CNIC_ISSUE_DATE }}</td>
                    <td>{{ item.BO_BENEFICIARY_CNIC_EXPIRY_DATE }}</td>

                    <!-- Director CNIC: BP_BENIOWNERSHIP -->
                    <td>{{ item.BO_DIRECTOR_CNIC_NO }}</td>
                    <td>{{ item.BO_DIRECTOR_CNIC_ISSUE_DATE }}</td>
                    <td>{{ item.BO_DIRECTOR_CNIC_EXPIRY_DATE }}</td>

                    <td>{{ item.BP_CNICVARIFICATINO }}</td>
                    <td>{{ item.CTY_NAME }}</td>
                    <td>{{ item.BPCRP_DATE }}</td>

                    <td align="center">
                      {{ item.BPCRP_SCORE === 'Low' ? '✔' : '' }}
                    </td>
                    <td align="center">
                      {{ item.BPCRP_SCORE === 'Medium' ? '✔' : '' }}
                    </td>
                    <td align="center">
                      {{ item.BPCRP_SCORE === 'High' ? '✔' : '' }}
                    </td>
                  </tr>
                </tbody>



              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        branch: '',
        clienttype: '',
        directorcnic: '',
        benificiarycnic: '',
        individualcnic: '',
        cnicverification: '',
        clients: [],
        loading: true,
      }
    },
    created: function () {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
          var vm = this;
          startReq();
            axios.post('/api/UICApi/loadClientReport', {
            BRANCH_ID: Number(urlParams.get('BRANCH_ID')),
            PTR_ID: Number(urlParams.get('PTR_ID')),
            Director: Number(urlParams.get('Director')),
            Benificiary: Number(urlParams.get('Benificiary')),
            Individual: Number(urlParams.get('Individual')),
            Verification: Number(urlParams.get('Verification')),
          })
            .then(function (res) {
              endReq();
              vm.clients = res.data.clients;
              vm.branch = res.data.branch;
              vm.clienttype = res.data.clienttype;
              vm.directorcnic = res.data.directorcnic;
              vm.benificiarycnic = res.data.benificiarycnic;
              vm.individualcnic = res.data.individualcnic;
              vm.cnicverification = res.data.cnicverification;
              vm.loading = false;
            });
          var uri = window.location.toString();
          if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
          }
        }
      },

      getExportObject() {

        return {
          sheetName: "Client Reprt",
          tables: [
            { tbl: 'tbl2', name: 'Sheet1' },
          ]
        };

      },

    }
  })</script>
<style>
  .bg {
    background-color: lightgrey;
  }

  [data-tag=P] {
    color: green;
  }

  [data-tag=A] {
    color: red;
  }

  [data-tag=L] {
    color: blue;
  }

  [data-tag=H] {
    color: darkblue;
  }
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

    .header img {
      width: 100px;
      margin-right: 20px;
    }

  .header-text {
    flex: 1;
    text-align: center;
  }
  .report-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .report-table {
    width: 100%;
    min-width: 2200px;
    border-collapse: collapse;
    table-layout: auto;
  }

    .report-table th,
    .report-table td {
      border: 1px solid #dee2e6;
      padding: 8px;
      font-size: 12px;
      vertical-align: middle;
    }

    .report-table th {
      text-align: center;
      white-space: normal;
      overflow-wrap: break-word;
      line-height: 1.4;
    }

    .report-table td {
      white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/ims/ClientReportPrint.vue